

export const GOOGLE_PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=biz.earningscall.app";
export const APPLE_APP_STORE_URL = "https://apps.apple.com/app/id1626859464";
